// src/pages/coach/sessions/SessionsList.jsx
import React from "react";
import SessionsList from "../../../components/attendance/SessionsList";

const CoachSessionsList = () => {
    return <SessionsList role="COACH" />;
};

export default CoachSessionsList;
